const config = {
    //servBackEnd : "http://localhost:3001"
    //servBackEnd : "http://gtic.solinux.co:3003"
    servBackEnd : "https://cloud.gestionartic.com:3004"
    // servBackEnd : "https://cloud.gestionartic.com:3080"
 
};

export default config;


// WEBPACK FOOTER //
// ./src/config.js